const ProfileType = {
  SET_PROFILE_DETAILS: "SET_PROFILE_DETAILS",
  UPDATE_KYC_DOCUMENTS: "UPDATE_KYC_DOCUMENTS",
  UPDATE_PROFILE: "UPDATE_PROFILE",
  UPDATE_BANK_DETAILS: "UPDATE_BANK_DETAILS",
  BECOME_A_SELLER: "BECOME_A_SELLER",
  DASHBOARD_DATA: "DASHBOARD_DATA",
  SET_USER_TYPE: "SET_USER_TYPE",
  SET_NOTIFICATIONS: "SET_NOTIFICATIONS",
  SET_STATE_DATA: "SET_STATE_DATA",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  CHANGE_PRODUCT_VIEW_STATUS: "CHANGE_PRODUCT_VIEW_STATUS",
  SET_CITY_LIST: "SET_CITY_LIST",
  SET_ALL_CITY_LIST: "SET_ALL_CITY_LIST",
  SET_ERM_DETAILS: "SET_ERM_DETAILS",
  GET_LATEST_MESSAGE: "GET_LATEST_MESSAGE",
};

export interface UpdateKYC {
  gst: string;
  pan: string;
  aadhaar: number;
  panImage: string;
  gstImage: string;
  aadhaarFront: string;
  aadhaarBack: string;
  daf: string;
  cheque: string;
  profile: string;
  company: string;
  signature: string;
}

export interface UpdateProfile {
  name: string;
  repName: string;
  mobile: number;
  state: string;
  district: string;
  pincode: number;
  address: string;
  gstNo: any;
}

export interface UpdateBankDetails {
  bankName: string;
  bankAccount: number;
  ifscCode: string;
  bankBranch: string;
}

export interface userType {
  type: string;
}

export interface Notifications {
  limit: number;
  search: any;
  page: number;
  type: string;
}

export interface UpdateTermsConditions {
  terms_conditions: string;
}

export interface ChangePassword {
  old_password: any;
  new_password: any;
  confirm_password: any;
}

export interface ChangeProductViewStatus {
  id: number;
  product_view_status: string;
}

export interface GetCity {
  state_id: any;
}

export default ProfileType;
